var $3b445dfa261850fe$exports = {};
$3b445dfa261850fe$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data`,
            other: `Datas`
        })} selecionada(s) indispon\xedvel(is).`
};


export {$3b445dfa261850fe$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
